export default __webpack_public_path__ + "static/media/cert-fsi-HKIRC.ab471a08.jpg";